import { motion } from "framer-motion";

export default function PageHero({ overline, title, subtitle, children, actions }) {
  return (
    <section className="hero-glow relative -mt-[72px] overflow-hidden pt-[72px] text-white" data-testid="page-hero">
      <div className="mx-auto max-w-7xl px-5 pb-12 pt-12 lg:px-8 lg:pb-16 lg:pt-16">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }}
          className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            {overline && <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand-orange">{overline}</p>}
            <h1 className="mt-3 font-heading text-4xl font-extrabold tracking-tight sm:text-5xl" data-testid="page-hero-title">{title}</h1>
            {subtitle && <p className="mt-4 text-base text-white/70 md:text-lg">{subtitle}</p>}
          </div>
          {actions}
        </motion.div>
        {children}
      </div>
    </section>
  );
}
